module.exports = __webpack_public_path__ + "static/img/ry1.4bfe141c.png";